<canvas #ntCnvs
        id="ntCnvs"
        (mouseout)="onMouseOut($event)"
        (mousedown)="onMousePress($event)"
        (mouseup)="onMouseRelease($event)"
        (mousemove)="onMouseMove($event)"></canvas>
